(function() {
    'use strict';

    angular.module('allegro')
        .controller('AllegroSafetyInfoUpdateController', AllegroSafetyInfoUpdateController);

    AllegroSafetyInfoUpdateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroSafetyInformationsDataSrvc',
        'allegroSafetyInformationMessagesConst'
    ];

    function AllegroSafetyInfoUpdateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroSafetyInformationsDataSrvc,
        allegroSafetyInformationMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            text: []
        };

        self.account = {};
        self.safetyInformationData = {
            account: null,
            text: ''
        };

        self.getAccount = getAccount;
        self.getSafetyInformationData = getSafetyInformationData;
        self.updateSafetyInformation = updateSafetyInformation;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.loading = true;

            self.getSafetyInformationData($stateParams.pk).then(function(response) {
                if (response.account) {
                    return self.getAccount(response.account);
                }
            })
            .then(function(data) {
                self.loading = false;
            });
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function getSafetyInformationData(receiverPk){
            return allegroSafetyInformationsDataSrvc.get({pk: receiverPk})
                .$promise
                .then(function (response) {
                    self.safetyInformationData = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function updateSafetyInformation() {
            self.loading = true;
            allegroSafetyInformationsDataSrvc.update({pk: self.safetyInformationData.pk}, self.safetyInformationData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroSafetyInformationMessagesConst.update);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
